import { DEFAULT_ASCII_OPTIONS } from '../engine/pixelEffects/ascii';

export const initialOptions = {
    background: {
        remove: false,
        applyToBackground: false,
        behindSubject: false,
        layers: [],
        perImage: {},
    },
    effects: {
        enabled: false,
        style: 'tiles',
        tileSize: 16,
        gap: 2,
        tolerance: 100,
        showUnderlay: true,
        underlayOpacity: 25,
        disabledColorIds: [],
        ...DEFAULT_ASCII_OPTIONS,
    },
    autoApply: false,
    saveAs: '',
    normalize: false,
    imgQuality: 100,
    contrast: 0,
    brightness: 0,
    hue: 0,
    saturation: 0,
    vibrance: 0,
    sepia: 0,
    blur: 0,
    denoise: 0,
    noise: 0,
    ink: 0,
    rotate: 0,
    flipH: false,
    flipV: false,
    cropToRectangle: false,
    zoom: 0,
    resizeW: 'auto',
    resizeH: 'auto',
    invertRed: false,
    invertGreen: false,
    invertBlue: false,
    pixelate: 0,
    unsharpMask: {
        radius: 0,
        strength: 0,
    },
    vignette: {
        size: 0,
        amount: 0,
    },
    lensBlur: {
        radius: 0,
        brightness: 0,
        angle: 0,
    },
    watermark: {
        angle: 0,
        font: 'Open Sans',
        text: '',
        images: [],
        color: 'rgba(100, 100, 100, .9)',
        textSize: 25,
        imageSize: 100,
        imageOpacity: 100,
        position: {
            upperLeft: false,
            upperCenter: false,
            upperRight: false,
            centerLeft: false,
            center: false,
            centerRight: false,
            lowerLeft: false,
            lowerCenter: false,
            lowerRight: false,
        },
        imagesPosition: {
            upperLeft: false,
            upperCenter: false,
            upperRight: false,
            centerLeft: false,
            center: false,
            centerRight: false,
            lowerLeft: false,
            lowerCenter: false,
            lowerRight: false,
            overlay: false,
        },
        dragOver: {
            upperLeft: false,
            upperCenter: false,
            upperRight: false,
            centerLeft: false,
            center: false,
            centerRight: false,
            lowerLeft: false,
            lowerCenter: false,
            lowerRight: false,
            overlay: false,
        },
    },
};
